import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=10970d80&scoped=true&"
import script from "./Params.vue?vue&type=script&lang=js&"
export * from "./Params.vue?vue&type=script&lang=js&"
import style0 from "./Params.vue?vue&type=style&index=0&id=10970d80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10970d80",
  null
  
)

export default component.exports